import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const API_BASE = process.env.REACT_APP_API_URL || "";

function GoogleUsernamePage() {
  const [username, setUsername] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { saveAuth } = useAuth();
  const navigate = useNavigate();
  const completedRef = useRef(false);

  const signupToken = sessionStorage.getItem("googleSignupToken");

  useEffect(() => {
    if (!signupToken && !completedRef.current) {
      navigate("/signup");
    }
  }, [signupToken, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);

    try {
      const res = await fetch(`${API_BASE}/api/auth/google/complete`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ signupToken, username }),
      });
      const data = await res.json();

      if (!res.ok) {
        setError(data.error || "Signup failed");
        return;
      }

      completedRef.current = true;
      sessionStorage.removeItem("googleSignupToken");
      saveAuth(data.token, data.user);
      navigate("/");
    } catch {
      setError("Unable to connect to server. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  if (!signupToken && !completedRef.current) return null;

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1 className="auth-title">Choose a Username</h1>
        <p className="auth-subtitle">Pick a username for your Goal Guesser account</p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-field">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Letters, numbers, underscores"
              required
              autoComplete="username"
              disabled={submitting}
              autoFocus
            />
          </div>
          <button type="submit" className="auth-button" disabled={submitting}>
            {submitting ? "Creating account..." : "Continue"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default GoogleUsernamePage;
